import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';
import { useTheme } from '@/components/theme/theme-provider';
import { getLogoUrl } from '@/lib/utils';

export function TeamSwitcher({ isSidebarOpen }) {
  const { theme } = useTheme();
  const logoUrl = getLogoUrl(theme);
  const loginConfigs = JSON.parse(localStorage.getItem('logo'));

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton
          size="lg"
          className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground justify-center"
        >
          {isSidebarOpen ? (
            <img src={logoUrl} alt="logo" className="bg-cover h-20 w-fit" />
          ) : (
            <>
              <img
                src={loginConfigs?.faviconUrl}
                alt="favicon"
                className="max-md:hidden"
              />
              <img src={logoUrl} alt="logo" className="md:hidden h-20 w-fit" />
            </>
          )}
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
